<template>
    <div>
        <div class="d-flex py-2 flex-wrap justify-content-center align-items-center">
            <div
                v-if="availableYears.length > 0"
                class="btn-group domain-filter"
                role="group"
                aria-label="Year filter"
            >
                <button
                    type="button"
                    v-for="y in availableYears"
                    @click="yearFilter = y"
                    :style="
                        yearFilter === y
                            ? 'box-shadow: inset 0 -4px 0 0 #000000; color: black;'
                            : ''
                    "
                    class="btn btn-sm btn-light text-uppercase filter"
                >
                    {{ y }}
                </button>
            </div>
        </div>

        <div v-dragscroll class="timeline-widget position-relative w-100" style="cursor: grab;">
            <div
                class="-months d-flex justify-content-start"
                :style="{
                    minHeight: Math.max(12, 2 + filteredTreatments.length * 1.1 + 3) + 'rem',
                }"
            >
                <div class="-month text-center font-weight-bold mh-100 pt-2">JANUARY</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">FEBRUARY</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">MARCH</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">APRIL</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">MAY</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">JUNE</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">JULY</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">AUGUST</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">SEPTEMBER</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">OCTOBER</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">NOVEMBER</div>
                <div class="-month text-center font-weight-bold mh-100 pt-2">DECEMBER</div>
            </div>
            <div class="-treatments d-flex flex-column position-absolute">
                <span
                    v-for="(t, i) in filteredTreatments"
                    class="-line position-absolute"
                    :style="getAppointmentStyle(t, i)"
                >
                    {{
                        moment(t.date_start)
                            .format("MMM DD")
                            .toUpperCase()
                    }}
                    -
                    {{
                        moment(t.date_end)
                            .format("MMM DD")
                            .toUpperCase()
                    }}
                    &nbsp;
                    {{ specialists.find(s => s.id === t.specialist).name }}
                    &nbsp;
                    {{ t.service }}
                </span>
            </div>
            <div
                class="-tests d-flex flex-column position-absolute"
                :style="{ top: Math.max(9, 2 + filteredTreatments.length * 1.1) + 'rem' }"
            >
                <hr
                    style="width:1080px;margin:auto;color:#313236;background: #313236; height: 4px; margin-bottom: 1rem;"
                />
                <span
                    v-for="(t, i) in filteredTests"
                    class="-test position-absolute pl-2"
                    :style="{
                        borderLeft: 'solid 2px ' + t.color,
                        left: moment(t.date_start).dayOfYear() * ((90 * 12) / 365) + 'px',
                        top: '0.5rem',
                        height: '2rem',
                    }"
                >
                    {{
                        moment(t.date_start)
                            .format("MMM DD")
                            .toUpperCase()
                    }}<br />
                    {{ specialists.find(s => s.id === t.specialist).area }}
                </span>
            </div>
        </div>
        <div class="d-flex py-2 flex-wrap justify-content-start align-items-center">
            <div class="btn-group domain-filter" role="group" aria-label="Timeline filter">
                <button
                    type="button"
                    @click="timelineFilter = 0"
                    :style="
                        timelineFilter === 0
                            ? 'box-shadow: inset 0 -4px 0 0 #000000; color: black;'
                            : ''
                    "
                    class="btn btn-sm btn-light text-uppercase filter"
                >
                    All
                </button>
                <button
                    type="button"
                    @click="timelineFilter = 1"
                    :style="
                        timelineFilter === 1
                            ? 'box-shadow: inset 0 -4px 0 0 #000000; color: black;'
                            : ''
                    "
                    class="btn btn-sm btn-light text-uppercase filter"
                >
                    Current therapy
                </button>
                <button
                    type="button"
                    @click="timelineFilter = 2"
                    :style="
                        timelineFilter === 2
                            ? 'box-shadow: inset 0 -4px 0 0 #000000; color: black;'
                            : ''
                    "
                    class="btn btn-sm btn-light text-uppercase filter"
                >
                    Past therapy
                </button>
                <button
                    type="button"
                    @click="timelineFilter = 3"
                    :style="
                        timelineFilter === 3
                            ? 'box-shadow: inset 0 -4px 0 0 #000000; color: black;'
                            : ''
                    "
                    class="btn btn-sm btn-light text-uppercase filter"
                >
                    Tests
                </button>
            </div>
        </div>
        <div class="px-3 pb-4">
            <div class="row p-1 table-header">
                <div class="col-3 text-uppercase text-white"><small>Dates</small></div>
                <div class="col-4 text-uppercase text-white"><small>Specialist</small></div>
                <div class="col-4 text-uppercase text-white"><small>Service provided</small></div>
                <div class="col-1 text-uppercase text-white"></div>
            </div>
            <timeline-new-entry :specialists="specialists"></timeline-new-entry>
            <template v-for="(e, i) in entries">
                <timeline-entry
                    v-if="!(entry && entry.id === e.id)"
                    :key="e.id"
                    :entry="e"
                    :specialists="specialists"
                    @edit-entry="entry = $event"
                ></timeline-entry>
                <timeline-new-entry
                    v-if="entry && entry.id === e.id"
                    :key="e.id"
                    :specialists="specialists"
                    @edit-done="closeEdit($event)"
                    :entry="entry"
                ></timeline-new-entry>
            </template>
        </div>
    </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";
import TimelineNewEntry from "./TimelineNewEntry";
import TimelineEntry from "./TimelineEntry";
export default {
    name: "Timeline",
    props: ["patient"],
    directives: {
        dragscroll: dragscroll,
    },
    components: {
        TimelineEntry,
        TimelineNewEntry,
    },
    data() {
        return {
            timelineFilter: 0,
            yearFilter: 2018,
            entry: null,
            specialists: [
                {
                    id: 1,
                    name: "Leanna Foster",
                    area: "SLP",
                    phone: "(555) 555-5555",
                    email: "leannafoster@clinic.com",
                },
            ],
            entries: [
                {
                    id: 1,
                    date_start: "2018-06-15",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#b36cd5",
                },
                {
                    id: 2,
                    date_start: "2018-03-16",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#f4b72a",
                },
                {
                    id: 3,
                    date_start: "2018-04-15",
                    date_end: "2018-06-20",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#78c625",
                },
                {
                    id: 4,
                    date_start: "2018-02-27",
                    date_end: "2018-07-13",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#b36cd5",
                },
                {
                    id: 5,
                    date_start: "2018-04-08",
                    date_end: "2018-09-15",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#f4b72a",
                },
                {
                    id: 6,
                    date_start: "2018-04-09",
                    date_end: "2019-09-15",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#4bc1cf",
                },
                {
                    id: 7,
                    date_start: "2017-10-27",
                    date_end: "2018-04-09",
                    specialist: 1,
                    service: "1hr / 1wk",
                    color: "#55b2fc",
                },
            ],
        };
    },
    watch: {
        patient() {
            if (this.patient) {
                this.getData();
            }
        },
    },
    computed: {
        filteredTreatments() {
            let filteredTreatments = [];
            filteredTreatments = this.entries.filter(e =>
                [this.moment(e.date_start).year(), this.moment(e.date_end).year()].includes(
                    this.yearFilter
                )
            );
            switch (this.timelineFilter) {
                case 3:
                    return [];
                case 2:
                    return filteredTreatments.filter(
                        e => e.date_end && this.moment(e.date_end) < this.moment()
                    );
                case 1:
                    return filteredTreatments.filter(
                        e => e.date_end && this.moment(e.date_end) >= this.moment()
                    );
                case 0:
                    return filteredTreatments.filter(e => e.date_end);
            }
        },
        filteredTests() {
            let filteredTests = [];
            filteredTests = this.entries.filter(
                e => this.moment(e.date_start).year() === this.yearFilter && !e.date_end
            );
            switch (this.timelineFilter) {
                case 3:
                case 0:
                    return filteredTests;
                case 2:
                case 1:
                    return [];
            }
        },
        availableYears() {
            let minYear = this.entries
                .map(e => this.moment(e.date_start).year())
                .reduce((a, b) => Math.min(a, b));
            let maxYearStart = this.entries
                .map(e => this.moment(e.date_start).year())
                .reduce((a, b) => Math.max(a, b));
            let maxYearEnd = this.entries
                .map(e => this.moment(e.date_end).year())
                .reduce((a, b) => Math.max(a, b));
            let maxYear = Math.max(maxYearEnd, maxYearStart);
            if (minYear === maxYear) {
                return minYear;
            }
            let availableYears = [];
            while (minYear <= maxYear) {
                availableYears.push(minYear);
                minYear++;
            }
            return availableYears;
        },
    },
    methods: {
        getAppointmentStyle(t, i) {
            return {
                backgroundColor: t.color,
                left:
                    (this.moment(t.date_start).year() === this.yearFilter
                        ? this.moment(t.date_start).dayOfYear() * ((90 * 12) / 365)
                        : 0) + "px",
                width:
                    (this.moment(t.date_end).year() === this.yearFilter
                        ? this.moment(t.date_start).year() === this.yearFilter
                            ? (this.moment(t.date_end).dayOfYear() -
                                  this.moment(t.date_start).dayOfYear()) *
                              ((90 * 12) / 365)
                            : this.moment(t.date_end).dayOfYear() * ((90 * 12) / 365)
                        : (365 - this.moment(t.date_start).dayOfYear()) * ((90 * 12) / 365)) + "px",
                top: 1 + (i - 1) * 1.1 + "rem",
            };
        },
        getData() {
            //TODO: fill according to API endpoint
            let endpoint = "";
            axios
                .get(`${endpoint}${this.patient.id}`)
                .then(r => {
                    this.newData = {};
                    this.editing = false;
                })
                .catch(e => {
                    console.error(e);
                });
        },
        closeEdit(entry) {
            if (entry) {
                //Dummy edit
                let edit = this.entries.find(e => e.id === entry.id);
                edit = entry;
            }
            this.entry = null;
        },
    },
};
</script>

<style scoped lang="scss">
.filter {
    font-size: 0.45rem;
    font-weight: 500;
    border-radius: 0;
    background-color: #fcfcfc;
    color: #aeaeae;
}
@media screen and (min-width: 576px) {
    .filter {
        font-size: 0.7rem;
    }
}

.table-header {
    background-color: #323337;
}

.pop-up {
    border: solid 1px #8f8f8f;
    z-index: 1;
    top: 0;
    left: 0;
}

.filter-options {
    columns: 2;
    list-style: none;
}

.timeline-widget {
    overflow-x: scroll;
    > .-months {
        > .-month {
            min-width: 90px;
            max-width: 90px;
            background-color: #ffffff;
            border: solid 1px #bfbfbf;
            font-size: 80%;
        }
        > .-month:first-child {
            border-left: solid 2px #bfbfbf;
        }
        > .-month:not(:first-child) {
            border-left: solid 1px #bfbfbf;
        }
        > .-month:last-child {
            border-right: solid 2px #bfbfbf;
        }
    }
    > .-treatments {
        top: 2rem;
        left: 0;
        > .-line {
            border-radius: 2px;
            font-size: 70%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
    > .-tests {
        > .-test {
            font-size: 70%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
}
</style>
